import { render, staticRenderFns } from "./vehicle_fault_info.vue?vue&type=template&id=4b678b14"
import script from "./vehicle_fault_info.vue?vue&type=script&lang=js"
export * from "./vehicle_fault_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports